import { render, staticRenderFns } from "./Struct.vue?vue&type=template&id=a216102e"
import script from "./Struct.vue?vue&type=script&lang=js"
export * from "./Struct.vue?vue&type=script&lang=js"
import style0 from "./Struct.vue?vue&type=style&index=0&id=a216102e&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a216102e')) {
      api.createRecord('a216102e', component.options)
    } else {
      api.reload('a216102e', component.options)
    }
    module.hot.accept("./Struct.vue?vue&type=template&id=a216102e", function () {
      api.rerender('a216102e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/components/formSetting/components/form-create-designer/src/components/Struct.vue"
export default component.exports